/**
 * Set the county fees for the Discretionary Tax County Fee Dropdown.
 * @note: The values (scond item in the array) should be in a "pipe"
 * format of <county name>|<county fee>.
 * @type {Array}
 */
const counties = [
  ['Choose County', '0'],
  ['Alachua', 'Alachua|0.005'],
  ['Baker', 'Baker|0.01'],
  ['Bay', 'Bay|0.01'],
  ['Bradford', 'Bradford|0.01'],
  ['Brevard', 'Brevard|0.01'],
  ['Broward', 'Broward|0'],
  ['Calhoun', 'Calhoun|0.015'],
  ['Charlotte', 'Charlotte|0.01'],
  ['Citrus', 'Citrus|0'],
  ['Clay', 'Clay|0.01'],
  ['Collier', 'Collier|0'],
  ['Columbia', 'Columbia|0.01'],
  ['Dade (same Miami-Dade)', 'Dade (same Miami-Dade)|0.01'],
  ['DeSoto', 'DeSoto|0.015'],
  ['Dixie', 'Dixie|0.01'],
  ['Duval', 'Duval|0.01'],
  ['Escambia', 'Escambia|0.015'],
  ['Flagler', 'Flagler|0.01'],
  ['Franklin', 'Franklin|0.01'],
  ['Gadsden', 'Gadsden|0.015'],
  ['Gilchrist', 'Gilchrist|0.01'],
  ['Glades', 'Glades|0.01'],
  ['Gulf', 'Gulf|0.01'],
  ['Hamilton', 'Hamilton|0.01'],
  ['Hardee', 'Hardee|0.01'],
  ['Hendry', 'Hendry|0.01'],
  ['Hernando', 'Hernando|0.005'],
  ['Highlands', 'Highlands|0.015'],
  ['Hillsborough', 'Hillsborough|0.01'],
  ['Holmes', 'Holmes|0.01'],
  ['Indian River', 'Indian River|0.01'],
  ['Jackson', 'Jackson|0.015'],
  ['Jefferson', 'Jefferson|0.01'],
  ['Lafayette', 'Lafayette|0.01'],
  ['Lake', 'Lake|0.01'],
  ['Lee', 'Lee|0'],
  ['Leon', 'Leon|0.015'],
  ['Levy', 'Levy|0.01'],
  ['Liberty', 'Liberty|0.02'],
  ['Madison', 'Madison|0.015'],
  ['Manatee', 'Manatee|0.01'],
  ['Marion', 'Marion|0.01'],
  ['Martin', 'Martin|0'],
  ['Miami-Dade', 'Miami-Dade|0.01'],
  ['Monroe', 'Monroe|0.015'],
  ['Nassau', 'Nassau|0.01'],
  ['Okaloosa', 'Okaloosa|0'],
  ['Okeechobee', 'Okeechobee|0.01'],
  ['Orange', 'Orange|0.005'],
  ['Osceola', 'Osceola|0.015'],
  ['Palm Beach', 'Palm Beach|.01'],
  ['Pasco', 'Pasco|0.01'],
  ['Pinellas', 'Pinellas|0.01'],
  ['Polk', 'Polk|0.01'],
  ['Putnam', 'Putnam|0.01'],
  ['St. Johns', 'St. Johns|.005'],
  ['St Lucie', 'St Lucie|0.005'],
  ['Santa Rosa', 'Santa Rosa|0.01'],
  ['Sarasota', 'Sarasota|0.01'],
  ['Seminole', 'Seminole|0.01'],
  ['Sumter', 'Sumter|0.01'],
  ['Suwannee', 'Suwannee|0.01'],
  ['Taylor', 'Taylor|0.01'],
  ['Union', 'Union|0.01'],
  ['Volusia', 'Volusia|0.005'],
  ['Wakulla', 'Wakulla|0.01'],
  ['Walton', 'Walton|0.01'],
  ['Washington', 'Washington|0.01'],
];

export default counties;



// WEBPACK FOOTER //
// ./src/modules/data/counties.js